import firebase from '../firebase';

interface RequestMetaOptions {
  headers: Record<string, string>;
  method: string;
  mode: RequestMode;
  cache: RequestCache;
}

const getRequestMeta = async (token: string, method: string = 'GET', contentType: string = ''): Promise<RequestMetaOptions> => {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
    'X-Firebase-AppCheck': await firebase.getAppCheckToken(),
    Accept: 'application/json',
  };

  if (method !== 'GET' && contentType === 'JSON') {
    headers['Content-Type'] = 'application/json';
  }

  return {
    headers,
    method,
    mode: 'cors',
    cache: 'no-cache',
  };
};
/**
 * Generates the required public request metadatas. Same as 'getRequestMeta', but without token.
 * @param {string} gToken Google recaptcha response token.
 * @param {'GET'|'POST'|'PUT'|'DELETE'} method HTTP request method.
 * @param {'JSON'} [contentType] Body content type to sent.
 * @param {string} [basicAuth] Basic auth credentials. Ex.: 'email:password'.
 * @returns Required metadatas.
 */
export const getPublicRequestMeta = (gToken: string, method: string = 'GET', contentType: string = '', basicAuth: string) : RequestMetaOptions => {
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'g-recaptcha-response': gToken,
  };

  if (basicAuth) headers.Authorization = `Basic ${Buffer.from(basicAuth, 'utf8').toString('base64')}`;
  if (method !== 'GET' && contentType === 'JSON') headers['Content-Type'] = 'application/json';

  return {
    headers,
    method,
    mode: 'cors',
    cache: 'no-cache',
  };
};

export default getRequestMeta;
